import { useCallback, useState } from "react";

import { Holding } from "../../../../services/holdings";
import { HoldingTradeAction } from "../../panels";
import { UseHoldingTradePanelReturn } from "./types";

// The holding is kept as the whole row rather than an id: the panel needs its quantity and openedAt, and re-looking it up would go stale against the ledger refetch a trade fires.
export const useHoldingTradePanel = (): UseHoldingTradePanelReturn => {
  const [panel, setPanel] = useState<UseHoldingTradePanelReturn["panel"]>({
    isOpen: false,
    action: "sell",
    holding: null,
  });

  const openPanel = useCallback(
    (action: HoldingTradeAction, holding: Holding) => {
      setPanel({ isOpen: true, action, holding });
    },
    [],
  );

  const closePanel = useCallback(() => {
    setPanel((prev) => ({ ...prev, isOpen: false, holding: null }));
  }, []);

  return { panel, openPanel, closePanel };
};
